import React from 'react';

export default class DigitsData extends React.Component {
  render() {
    const Row = (props) => (
      <tr>
        <th>{props.title}</th>
        <td>{props.value}</td>
      </tr>
    );

    return (
      <div>
        <table>
            <tbody>
              <Row title="Digit integer heights" value={this.props.integerDigitHeights} />
              <Row title="Digit decimal heights" value={this.props.decimalDigitHeights} />
              <Row title="Digit integer widths" value={this.props.integerDigitWidths} />
              <Row title="Digit decimal widths" value={this.props.decimalDigitWidths} />
            </tbody>
        </table>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./client/components/DigitsData.js